import loadable from '@loadable/component';

export const LivingetcSiteWrapper = loadable(
  () => import(/* webpackChunkName: "livingetc-site" */ './LivingetcSiteWrapper'),
);
